<a (click)="onClickAnchor($event)" [href]="url"
   class="flex text-decoration-none"
   rel="noopener"
   target="_blank">
  <mat-icon [matTooltip]="getTooltip()"
            class="table-icon font-medium">{{ icon }}
  </mat-icon>
  <span class="m-l-5">{{ text }}</span>
</a>
